// Favorites: tracks recency + supports manual pinning
const KEY = "verihandi_tool_usage";
const PIN_KEY = "verihandi_tool_pins";

export function recordToolUse(path) {
  try {
    const raw = localStorage.getItem(KEY);
    const map = raw ? JSON.parse(raw) : {};
    map[path] = Date.now();
    localStorage.setItem(KEY, JSON.stringify(map));
  } catch { /* ignore */ }
}

function getPins() {
  try { return JSON.parse(localStorage.getItem(PIN_KEY) || "[]"); } catch { return []; }
}

export function togglePin(path) {
  const pins = getPins();
  const i = pins.indexOf(path);
  if (i >= 0) pins.splice(i, 1);
  else pins.push(path);
  localStorage.setItem(PIN_KEY, JSON.stringify(pins));
  window.dispatchEvent(new Event("favorites-changed"));
  return pins.includes(path);
}

export function isPinned(path) {
  return getPins().includes(path);
}

export function getFavorites(limit = 4) {
  try {
    const pins = getPins();
    const raw = localStorage.getItem(KEY);
    const map = raw ? JSON.parse(raw) : {};
    const recency = Object.entries(map).sort(([, a], [, b]) => b - a).map(([p]) => p);
    // pins always first (in order added), then recent unique (excluding pins)
    const result = [];
    for (const p of pins) if (!result.includes(p)) result.push(p);
    for (const p of recency) if (!result.includes(p)) result.push(p);
    return result.slice(0, limit);
  } catch {
    return [];
  }
}
